import { useState, useCallback } from 'react';
import { QueryKey } from 'react-query';

import { ID } from '../../../../../../../types';
import {
  UniversalFilterItemTagsValue,
  UniversalFilterItemTagsModes,
  UniversalFilterItemTagsFilterState,
  UniversalFilterItemTagsOnFilterStateChange,
  UniversalFilterItemTagsOnChange
} from '../../UniversalFilterItemTags.types';

import { useMountEffect } from '../../../../../../../common/hooks/useMountEffect';
import { useReactQueryState } from '../../../../../../../main/common/reactQuery/hooks/useReactQueryState';

import { useUniversalFilterItemTagsFilterState } from '../useUniversalFilterItemTagsFilterState';

import {
  UniversalFilterTemplateModeOption,
  UniversalFilterTemplateOnModeChange
} from '../../../../helpers/UniversalFilterTemplate';

import { filtersKeys } from '../../../../../../../locales/keys';

const defaultMode = UniversalFilterItemTagsModes.CONTAINS_ALL_OF;

const modeOptions: UniversalFilterTemplateModeOption<UniversalFilterItemTagsModes>[] =
  [
    // {
    //   value: UniversalFilterItemTagsModes.CONTAINS_ANY_OF,
    //   i18nText: filtersKeys.modes.containsAnyOf
    // }
    {
      value: UniversalFilterItemTagsModes.CONTAINS_ALL_OF,
      i18nText: filtersKeys.modes.containsAllOf
    }
    // {
    //   value: UniversalFilterItemTagsModes.CONTAINS_ONLY,
    //   i18nText: filtersKeys.modes.containsOnly
    // },
    // {
    //   value: UniversalFilterItemTagsModes.CONTAINS_NONE_OF,
    //   i18nText: filtersKeys.modes.containsNoneOf
    // },
    // {
    //   value: UniversalFilterItemTagsModes.DOES_NOT_CONTAIN_ANY_OF,
    //   i18nText: filtersKeys.modes.doesNotContainAnyOf
    // }
    // {
    //   value: UniversalFilterItemTagsModes.IS_EMPTY,
    //   i18nText: filtersKeys.modes.isEmpty
    // },
    // {
    //   value: UniversalFilterItemTagsModes.IS_NOT_EMPTY,
    //   i18nText: filtersKeys.modes.isNotEmpty
    // }
  ];

interface UniversalFilterItemTagsOptions {
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterItemTagsValue;
  onChange: UniversalFilterItemTagsOnChange;
}

function useUniversalFilterItemTags({
  filterStateCacheKey,
  filterValue,
  onChange
}: UniversalFilterItemTagsOptions) {
  const { value: savedState, setValue: saveState } =
    useReactQueryState<UniversalFilterItemTagsFilterState>(filterStateCacheKey);

  const { handleApplyFilterState, handleParseFilterValue } =
    useUniversalFilterItemTagsFilterState({
      onChange
    });

  const [filterState, setFilterState] =
    useState<UniversalFilterItemTagsFilterState>(
      savedState ||
        handleParseFilterValue(filterValue) || {
          mode: defaultMode,
          itemTagIds: []
        }
    );

  useMountEffect(() => {
    handleApplyFilterState(filterState);
  });

  const handleFilterStateChange =
    useCallback<UniversalFilterItemTagsOnFilterStateChange>(
      (state) => {
        setFilterState(state);
        handleApplyFilterState(state);
        saveState(state);
      },
      [handleApplyFilterState, saveState]
    );

  const handleModeChange = useCallback<
    UniversalFilterTemplateOnModeChange<UniversalFilterItemTagsModes>
  >(
    (mode) => {
      handleFilterStateChange({
        mode,
        itemTagIds: filterState.itemTagIds || []
      });
    },
    [filterState, handleFilterStateChange]
  );

  const handleUserIdsChange = useCallback<(invoiceIds: ID[]) => void>(
    (invoiceIds) => {
      handleFilterStateChange({
        mode: filterState.mode,
        itemTagIds: invoiceIds || []
      });
    },
    [filterState, handleFilterStateChange]
  );

  return {
    modeOptions,
    filterState,
    handleModeChange,
    handleUserIdsChange
  };
}

export default useUniversalFilterItemTags;
